import React from 'react';

const CommandCenterFilterBar = ({ timeframe, onChangeTimeframe, areaFilter, onChangeArea, areaOptions, onRefresh }) => {
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-3">
      <div className="grid gap-3 md:grid-cols-4">
        <div>
          <label className="mb-1 block text-[11px] uppercase tracking-wide text-slate-400">Timeframe</label>
          <select
            value={timeframe}
            onChange={(e) => onChangeTimeframe?.(e.target.value)}
            className="w-full rounded-lg border border-slate-700 bg-slate-950/80 px-2 py-2 text-sm text-slate-100"
          >
            <option value="today">Today</option>
            <option value="7d">7 Days</option>
            <option value="30d">30 Days</option>
          </select>
        </div>
        <div>
          <label className="mb-1 block text-[11px] uppercase tracking-wide text-slate-400">Area</label>
          <select
            value={areaFilter}
            onChange={(e) => onChangeArea?.(e.target.value)}
            className="w-full rounded-lg border border-slate-700 bg-slate-950/80 px-2 py-2 text-sm text-slate-100"
          >
            <option value="all">Semua Area</option>
            {(areaOptions || []).map((area) => (
              <option key={area} value={area}>
                {area}
              </option>
            ))}
          </select>
        </div>
        <div className="md:col-span-2 flex items-end justify-end">
          <button
            type="button"
            onClick={onRefresh}
            className="rounded-lg border border-cyan-500/40 bg-cyan-500/10 px-3 py-2 text-sm font-medium text-cyan-200 hover:bg-cyan-500/20"
          >
            Refresh Command Center
          </button>
        </div>
      </div>
    </section>
  );
};

export default CommandCenterFilterBar;
